import styled from 'styled-components';
import {
  color,
  space,
  typography,
  layout,
  flexbox,
  border,
  grid,
  shadow,
} from 'styled-system';

export const Box = styled('div')(
  color,
  space,
  typography,
  layout,
  grid,
  flexbox,
  border,
  shadow
);
